import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=0607878c&"
import script from "./partner.vue?vue&type=script&lang=ts&"
export * from "./partner.vue?vue&type=script&lang=ts&"
import style0 from "./partner.vue?vue&type=style&index=0&lang=less&rel=stylesheet%2Fless&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports